(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["eros-big-logo"] && !Shopify.designMode) return;
  try {
    
  (function () {
    /* Detect any open dialog/drawer and force the big logo into shrunk state.
       Covers Horizon's mobile menu, cart drawer, search, quick-view — anything
       that uses <dialog open> or aria-expanded="true" on a dialog component. */
    var observer, running = false;

    function update() {
      var anyOpen = !!document.querySelector(
        'dialog[open], dialog-component[open], [data-open="true"][role="dialog"], .drawer--open, details[scroll-lock][open], details#Details-menu-drawer-container[open], header-drawer details[open], cart-drawer details[open]'
      );
      /* Also check body for Horizon's typical scroll-lock class */
      if (!anyOpen) {
        var bc = document.body.className || '';
        if (/\b(drawer-open|menu-open|overlay-open|scroll-lock|is-drawer-open)\b/.test(bc)) anyOpen = true;
      }
      document.querySelectorAll('.eros-big-logo').forEach(function (el) {
        el.classList.toggle('is-menu-open', anyOpen);
      });
    }

    function start() {
      if (running) return;
      running = true;
      observer = new MutationObserver(function () { update(); });
      observer.observe(document.documentElement, {
        subtree: true,
        attributes: true,
        attributeFilter: ['open', 'class', 'aria-expanded', 'data-open']
      });
      update();
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
    else start();
    document.addEventListener('shopify:section:load', start);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eros-country-gate"] && !Shopify.designMode) return;
  try {
    
  class ErosCountryGate extends HTMLElement {
    constructor() {
      super();
      this.STORAGE_KEY = 'eros_gate_choice';
      this.DISMISS_KEY = 'eros_gate_dismissed_at';
    }

    connectedCallback() {
      if (!this.shouldOpen()) return;

      // Slight delay to avoid fighting LCP paint
      setTimeout(() => this.open(), 600);

      this.addEventListener('click', (e) => {
        if (e.target.closest('[data-gate-close]')) {
          e.preventDefault();
          this.dismiss();
        }
        const opt = e.target.closest('[data-country-code]');
        if (opt) {
          e.preventDefault();
          this.choose(
            opt.dataset.countryCode,
            opt.dataset.countryUrl,
            opt.dataset.countryLabel
          );
        }
      });

      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && this.hasAttribute('open')) this.dismiss();
      });

      // Global helper: window.erosResetGate() reopens it for testing
      window.erosResetGate = () => {
        try {
          localStorage.removeItem(this.STORAGE_KEY);
          localStorage.removeItem(this.DISMISS_KEY);
        } catch (e) {}
        this.open();
      };
    }

    shouldOpen() {
      if (this.dataset.autoOpen === 'false') return false;
      if (window.Shopify && window.Shopify.designMode) return false; // not in editor
      try {
        if (localStorage.getItem(this.STORAGE_KEY)) return false;
        const dismissedAt = parseInt(localStorage.getItem(this.DISMISS_KEY) || '0', 10);
        if (dismissedAt && Date.now() - dismissedAt < 24 * 60 * 60 * 1000) return false;
      } catch (e) {}
      return true;
    }

    open() {
      this.removeAttribute('hidden');
      this.setAttribute('open', '');
      document.body.style.overflow = 'hidden';
    }

    dismiss() {
      this.setAttribute('hidden', '');
      this.removeAttribute('open');
      document.body.style.overflow = '';
      try { localStorage.setItem(this.DISMISS_KEY, String(Date.now())); } catch (e) {}
    }

    choose(code, url, label) {
      try {
        localStorage.setItem(this.STORAGE_KEY, JSON.stringify({ code: code, label: label, at: Date.now() }));
      } catch (e) {}
      this.setAttribute('hidden', '');
      this.removeAttribute('open');
      document.body.style.overflow = '';
      if (url && url !== window.location.pathname) {
        window.location.href = url;
      }
    }
  }

  if (!customElements.get('eros-country-gate')) {
    customElements.define('eros-country-gate', ErosCountryGate);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eros-look-detail"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(section) {
      if (section.dataset.ldInit) return;
      section.dataset.ldInit = '1';
      var btn = section.querySelector('[data-buy-look]');
      if (!btn) return;
      var code = section.dataset.discountCode || '';
      var variantIds = (section.dataset.variantIds || '').split(',').filter(Boolean).map(function (x) { return parseInt(x, 10); }).filter(Boolean);
      if (!variantIds.length) { btn.disabled = true; return; }

      btn.addEventListener('click', function (e) {
        e.preventDefault();
        if (btn.dataset.busy === '1') return;
        btn.dataset.busy = '1';
        var originalHTML = btn.innerHTML;
        btn.innerHTML = 'Adding ' + variantIds.length + ' items…';
        btn.disabled = true;

        var items = variantIds.map(function (id) { return { id: id, quantity: 1 }; });
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: items })
        })
        .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
        .then(function () {
          if (code) {
            window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=/cart';
          } else {
            window.location.href = '/cart';
          }
        })
        .catch(function () {
          btn.innerHTML = 'Something went wrong. Try again.';
          setTimeout(function () { btn.innerHTML = originalHTML; btn.disabled = false; btn.dataset.busy = '0'; }, 1800);
        });
      });
    }
    function initAll(root) { (root || document).querySelectorAll('[data-eros-look-detail]').forEach(init); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
    else initAll();
    document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eros-password"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.__erosPwCountdownInit) return;
  window.__erosPwCountdownInit = true;

  function tick(el) {
    var raw = el.dataset.target;
    var target = new Date(raw);
    if (isNaN(target.getTime())) {
      el.classList.add('is-complete');
      var eb = el.querySelector('.eros-pw__countdown-eyebrow');
      if (eb) eb.textContent = el.dataset.completeMsg || 'Live now';
      return;
    }
    var now = new Date();
    var ms = target - now;
    if (ms <= 0) {
      el.classList.add('is-complete');
      var eb2 = el.querySelector('.eros-pw__countdown-eyebrow');
      if (eb2) eb2.textContent = el.dataset.completeMsg || 'Live now';
      return false;
    }
    var d = Math.floor(ms / 86400000);
    var h = Math.floor((ms % 86400000) / 3600000);
    var m = Math.floor((ms % 3600000) / 60000);
    var s = Math.floor((ms % 60000) / 1000);
    function pad(n) { return n < 10 ? '0' + n : '' + n; }
    var nodes = el.querySelectorAll('[data-ec]');
    nodes.forEach(function (n) {
      var k = n.dataset.ec;
      var val = k === 'd' ? d : k === 'h' ? h : k === 'm' ? m : s;
      n.textContent = pad(val);
    });
    return true;
  }

  function init() {
    var els = document.querySelectorAll('[data-eros-countdown]');
    els.forEach(function (el) {
      tick(el);
      var iv = setInterval(function () {
        if (tick(el) === false) clearInterval(iv);
      }, 1000);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eros-shop-the-look"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(section) {
      if (section.dataset.stlInit) return;
      section.dataset.stlInit = '1';
      var track = section.querySelector('[data-stl-track]');
      if (!track) return;
      var prev = section.querySelector('[data-stl-prev]');
      var next = section.querySelector('[data-stl-next]');
      function step() {
        var card = track.querySelector('.eros-stl__card');
        if (!card) return 400;
        var rect = card.getBoundingClientRect();
        var style = getComputedStyle(track);
        var gap = parseFloat(style.columnGap || style.gap || 0) || 0;
        return rect.width + gap;
      }
      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left:  step(), behavior: 'smooth' }); });
    }
    function initAll(root) { (root || document).querySelectorAll('[data-eros-stl-carousel]').forEach(init); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
    else initAll();
    document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
